/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest,
  PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
  PostApiV1ExamQuestionLibraryAiCorrection400,
  PostApiV1ExamQuestionLibraryAiCorrection401,
  PostApiV1ExamQuestionLibraryAiCorrection500,
} from "../../types/examQuestionLibraryController/PostApiV1ExamQuestionLibraryAiCorrection.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamQuestionLibraryAiCorrection } from "../../clients/examQuestionLibraryController/postApiV1ExamQuestionLibraryAiCorrection.ts";

export const postApiV1ExamQuestionLibraryAiCorrectionMutationKey = () =>
  [{ url: "/api/v1/exam/question-library/ai-correction" }] as const;

export type PostApiV1ExamQuestionLibraryAiCorrectionMutationKey = ReturnType<
  typeof postApiV1ExamQuestionLibraryAiCorrectionMutationKey
>;

export function postApiV1ExamQuestionLibraryAiCorrectionMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1ExamQuestionLibraryAiCorrectionMutationKey();
  return mutationOptions<
    PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryAiCorrection400
      | PostApiV1ExamQuestionLibraryAiCorrection401
      | PostApiV1ExamQuestionLibraryAiCorrection500
    >,
    { data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamQuestionLibraryAiCorrection(data, config);
    },
  });
}

/**
 * @description Revisa uma questão na biblioteca de questões utilizando inteligência artificial. O tipo do componente determina quais campos são obrigatórios e qual estratégia de revisão é aplicada.
 * Para questões **MultilineText com subtipo**, a IA aplica critérios específicos por subtipo:
 * - **OpinionArticle** (1): avalia se o enunciado propõe tema debatível, convida ao posicionamento e tem escopo adequado.
 * - **Essay** (2): avalia clareza, nível cognitivo, aderência ao conteúdo e ausência de ambiguidade.
 * - **ModelAnswerEssay** (3): revisa enunciado, resposta-modelo e termos-chave. Requer `modelAnswer`.
 * - **MbaCase** (4): revisa enunciado e Notas de Ensino (gabarito técnico). Requer `modelAnswer`.
 * Para questões de lista (SingleChoice ou MultipleChoice), informe as alternativas no campo `ExamTypeList`. **(Requer Authorization para autenticação)**
 * @summary Revisão de questão com AI (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library/ai-correction}
 */
export function usePostApiV1ExamQuestionLibraryAiCorrection<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamQuestionLibraryAiCorrection400
        | PostApiV1ExamQuestionLibraryAiCorrection401
        | PostApiV1ExamQuestionLibraryAiCorrection500
      >,
      { data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamQuestionLibraryAiCorrectionMutationKey();

  const baseOptions = postApiV1ExamQuestionLibraryAiCorrectionMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryAiCorrection400
      | PostApiV1ExamQuestionLibraryAiCorrection401
      | PostApiV1ExamQuestionLibraryAiCorrection500
    >,
    { data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryAiCorrection400
      | PostApiV1ExamQuestionLibraryAiCorrection401
      | PostApiV1ExamQuestionLibraryAiCorrection500
    >,
    { data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamQuestionLibraryAiCorrection400
      | PostApiV1ExamQuestionLibraryAiCorrection401
      | PostApiV1ExamQuestionLibraryAiCorrection500
    >,
    { data: PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest },
    TContext
  >;
}
